@if (form) {
  <form [formGroup]="form">
    <p-panel class="mb-4" header="Enter new Provider information">
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label>First Name:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="firstName" />
            </div>
          </div>
          <div class="field">
            <label>Last Name:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="lastName" />
            </div>
          </div>
          <div class="field">
            <label>NPI:</label>
              <div class="p-field-value">
                <p-input-mask
                  slotChar=""
                  mask="9999999999"
                  [maxlength]="10"
                  formControlName="practiceNpinumber"
                  [autoClear]="false"
                  data-test-id="npi-value"
                ></p-input-mask>
              </div>
          </div>
        </div>
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label>Street:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalStreet" />
            </div>
          </div>
          <div class="field">
            <label>City:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalCity" />
            </div>
          </div>
          <div class="field">
            <label>State:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalState" />
            </div>
          </div>
          <div class="field">
            <label>ZIP Code:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalZip" />
            </div>
          </div>
          <div class="field">
            <label>Phone:</label>
            <div class="p-field-value">
              <p-input-mask
                mask="(999) 999-9999"
                formControlName="phone"
                [unmask]="false"
                [autoClear]="false"
              ></p-input-mask>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
}
